import React from 'react';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  FormFieldsContainer,
  Inscription,
  Label,
  RegularField,
  useFormContext,
} from '@common-fe/common-fe';

import { EnrollmentFormField, EnrollmentFormFields } from './hooks/useEnrollmentForm';

const IdentifiersSection: React.FC = () => {
  const { control, getValues } = useFormContext<EnrollmentFormFields>();

  const EEID = getValues(EnrollmentFormField.employerEmployeeId);
  const PEID = getValues(EnrollmentFormField.partnerEmployeeId);
  const SSN = getValues(EnrollmentFormField.ssn);

  return (
    <FormFieldsContainer gap="spacing16" data-testid="deductible-form">
      <Box
        background="canvas"
        round="container1Round"
        pad="spacing24"
        border={{ size: '1px', color: 'border2' }}
        gap="m"
      >
        <Inscription size="20px">Identifiers</Inscription>
        <FieldWrapper style={{ justifyContent: 'space-between' }}>
          <Label name={EnrollmentFormField.tpaPartner} isNarrow>
            TPA/Partner
          </Label>
          <ControllerWrapper style={{ flex: 'none' }}>
            <Controller
              name={EnrollmentFormField.tpaPartner}
              control={control}
              render={({ field }) => (
                <RegularField
                  {...field}
                  disabled
                  placeholder="TPA/Partner"
                  style={{ width: '320px' }}
                  editMode
                  value={field.value ?? ''}
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>
        <FieldWrapper style={{ justifyContent: 'space-between' }}>
          <Label name="employer" isNarrow>
            Employer
          </Label>
          <ControllerWrapper style={{ flex: 'none' }}>
            <Controller
              name={EnrollmentFormField.employer}
              control={control}
              render={({ field }) => (
                <RegularField
                  {...field}
                  disabled
                  placeholder="Employer"
                  style={{ width: '320px' }}
                  editMode
                  value={field.value ?? ''}
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>
        {EEID && (
          <FieldWrapper style={{ justifyContent: 'space-between' }}>
            <Label name="employerEmployeeId" isNarrow>
              Employer Employee ID
            </Label>
            <ControllerWrapper style={{ flex: 'none' }}>
              <Controller
                name={EnrollmentFormField.employerEmployeeId}
                control={control}
                render={({ field }) => (
                  <RegularField
                    {...field}
                    disabled
                    placeholder="Employer Employee ID"
                    style={{ width: '320px' }}
                    editMode
                    value={field.value ?? ''}
                  />
                )}
              />
            </ControllerWrapper>
          </FieldWrapper>
        )}
        {PEID && (
          <FieldWrapper style={{ justifyContent: 'space-between' }}>
            <Label name="partnerEmployeeId" isNarrow>
              Partner Employee ID
            </Label>
            <ControllerWrapper style={{ flex: 'none' }}>
              <Controller
                name={EnrollmentFormField.partnerEmployeeId}
                control={control}
                render={({ field }) => (
                  <RegularField
                    {...field}
                    disabled
                    placeholder="Partner Employee ID"
                    style={{ width: '320px' }}
                    editMode
                    value={field.value ?? ''}
                  />
                )}
              />
            </ControllerWrapper>
          </FieldWrapper>
        )}
        {SSN && (
          <FieldWrapper style={{ justifyContent: 'space-between' }}>
            <Label name="ssn" isNarrow>
              SSN
            </Label>
            <ControllerWrapper style={{ flex: 'none' }}>
              <Controller
                name={EnrollmentFormField.ssn}
                control={control}
                render={({ field }) => (
                  <RegularField
                    {...field}
                    disabled
                    placeholder="SSN"
                    style={{ width: '320px' }}
                    editMode
                    value={field.value ?? ''}
                  />
                )}
              />
            </ControllerWrapper>
          </FieldWrapper>
        )}
        <FieldWrapper style={{ justifyContent: 'space-between' }}>
          <Label name="lastName" isNarrow>
            Last name
          </Label>
          <ControllerWrapper style={{ flex: 'none' }}>
            <Controller
              name={EnrollmentFormField.lastName}
              control={control}
              render={({ field }) => (
                <RegularField
                  {...field}
                  disabled
                  placeholder="Last name"
                  style={{ width: '320px' }}
                  editMode
                  value={field.value ?? ''}
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>
      </Box>
    </FormFieldsContainer>
  );
};

export default React.memo(IdentifiersSection);
